import React, { Fragment } from "react";

import BulkStartButton from "./bulkStartButton";
import BulkPauseButton from "./bulkPauseButton";

export default props => (
  <Fragment>
    <BulkStartButton {...props} />
    <BulkPauseButton {...props} />
  </Fragment>
);



// WEBPACK FOOTER //
// ./src/components/kioskBulkActionButtons.js